var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPostWrite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 9H13C10.7909 9 9 10.7891 9 12.9983V35.0035C9 37.2126 10.7909 39 13 39H35C37.2091 39 39 37.2091 39 35V13C39 10.7909 37.2091 9 35 9Z",
    stroke: "#BE69C2",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34 16.775C34 20.8375 29 24 29 24C29 24 24 20.8375 24 16.775C24 15.2375 25.25 14 26.775 14C27.6875 14 28.4875 14.4375 29 15.1C29.5125 14.4375 30.3125 14 31.2125 14C32.75 14 33.9875 15.2375 33.9875 16.775H34Z",
    fill: "#BE69C2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 29L25 29",
    stroke: "#BE69C2",
    strokeWidth: 1.4,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 33H31",
    stroke: "#BE69C2",
    strokeWidth: 1.4,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostWrite);
export default __webpack_public_path__ + "static/media/post_write.0c816aa6a96db3e0737b680d11530750.svg";
export { ForwardRef as ReactComponent };